import { apiClient, requiresAuth } from '../client';
import { JobsStatusResponse, TriggerJobResponse } from '../../types';

export const jobsService = {
  getStatus: async (): Promise<JobsStatusResponse> => {
    return requiresAuth(async () => {
      const response = await apiClient.get('/api/admin/jobs/status');
      return response.data.data;
    });
  },

  triggerStaleTiers: async (): Promise<TriggerJobResponse> => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/api/admin/jobs/stale-tiers/trigger');
      return response.data;
    });
  },

  triggerAtRisk: async (): Promise<TriggerJobResponse> => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/api/admin/jobs/at-risk/trigger');
      return response.data;
    });
  },

  triggerSAAssignment: async (): Promise<TriggerJobResponse> => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/api/admin/jobs/sa-assignment/trigger');
      return response.data;
    });
  },

  triggerWelcomeMessages: async (): Promise<TriggerJobResponse> => {
    return requiresAuth(async () => {
      const response = await apiClient.post('/api/admin/jobs/welcome-messages/trigger');
      return response.data;
    });
  },
};
